import { api } from '@/services/api'

/**
 * Atomically fetches the next code in a module's numbering series, e.g.
 * `generateCode('generators')` → "GEN014". Configured per module in Code
 * Master (/master/code-masters) — prefix, zero-padding, next running number.
 *
 * Pass `prefixOverride` to override the stored prefix for this call only.
 * If the prefix differs from what is currently in the DB the server
 * automatically resets the sequence to 1 and adopts the new prefix —
 * this is how MeterReading gets JUN26001 → JUL26001 etc. on month rollover.
 *
 * The series is incremented server-side the moment this is called, so only
 * call it right before an actual save — calling it and then abandoning the
 * form (e.g. user hits Cancel) leaves a gap in the sequence, same as any
 * running-number scheme.
 */
export async function generateCode(moduleKey: string, prefixOverride?: string): Promise<string> {
  const body: Record<string, string> = {}
  if (prefixOverride !== undefined) body.prefix = prefixOverride
  const result = await api.post<{ code: string }>(`/code-masters/generate/${moduleKey}`, body)
  return result.code
}
